import { Box } from '@jfs/ui-new'
import { defaultColors } from '@jfs/ui-new/src/theme/DefaultTheme'
import { useIsLargeScreen } from '@jfs/ui-new/src/utils/utils'
import { useNavigation } from '@react-navigation/native'
import { useEffect, useRef, useState } from 'react'
import { RefreshControl as RefreshControlMobile, ScrollView } from 'react-native'
import { RefreshControl as RefreshControlMobileWeb } from 'react-native-web-refresh-control'
import { ImageWithInfoSerializer } from '../../comps/ImageWithInfoSerializer/ImageWithInfoSerializer'
import { ListWithDateRange } from '../../comps/ListWithDateRange'
import { ShimmerView } from '../../comps/ShimmerView'
import { ToastPosition, ToastType } from '../../comps/Toast'
import { actionMenuStrings, staticStrings, transactionScreenStrings } from '../../data/static/strings'
import { RootStore, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { INFINITE_SCROLL_WINDOW, INFINITE_SCROLL_WINDOW_INDEX } from '../../util/common'
import {
  getErrorState,
  getLoadingState,
  getPrevDate,
  getSelectedDate,
  isMobile,
  isOsMobile,
  logEvent,
  tableConfig,
} from '../../util/util'
import { getFilterList } from './helper'
import { SearchBarWithFilters } from './SearchBarWithFilters'

const ReceivedTransactionNative = ({
  fetchTxnColumns,
  fetchTxn,
  fetchStatsApi,
  transactionApiHandlers,
  fetchTxnOnLoadMore,
  transactionApiLoadMoreHandlers,
  fetchTxnColumnsOnLoadMore,
  isFocused,
}: any) => {
  const navigation = useNavigation()
  const {
    mid,
    fetchDataForTransactionTab,
    resetPaginationTxn,
    fetchTransactionDetailsOfPath,
    pagination,
    loadMoreTxns,
    selectedDateInfo,
    onTransactionRetry,
    updateSelectedTxn,
    canViewTransactionDetails,
    moreTxnAvailable,
    isMaxDateRangeSelected,
    updateSelectedDateInfo,
    paginationResetToZero,
    updatePagination,
    filtersData,
    selectedDateInfoObj,
    clearReceivedFilters,
    clearRefundFilters,
    updateRefundedSelectedDateInfo,
    resetPaginationNativeRefunded,
    setSearchString,
  } = useStores((store) => ({
    mid: store.user.selectedMid,
    fetchDataForTransactionTab: store.transactions.fetchDataForTransactionTab,
    resetPaginationTxn: store.transactions.resetPaginationNativeRecieved,
    moreTxnAvailable: store.moreTxnAvailable,
    isMaxDateRangeSelected: store.isMaxDateRangeSelected,
    fetchTransactionDetailsOfPath: store.fetchTransactionDetailsOfPath,
    pagination: store.transactions.paginationRecived,
    loadMoreTxns: store.loadMoreTxns,
    selectedDateInfo: store.transactions.receivedSelectedDateInfo,
    onTransactionRetry: store.onTransactionRetry,
    length: store.transactions.received.length,
    updateSelectedTxn: store.transactions.updateSelectedTxn,
    canViewTransactionDetails: store.userManagement.canViewTransactionDetails(),
    updateSelectedDateInfo: store.transactions.updateReceivedSelectedDateInfo,
    paginationResetToZero: store.transactions.resetPaginationNativeRecievedToZero,
    updatePagination: store.transactions.updatePaginationNativeReceived,
    filtersData: store.transactions.receivedFilter.getFilterData,
    selectedDateInfoObj: store.transactions.selectedDateInfo,
    clearReceivedFilters: store.transactions.receivedFilter.clearFilters,
    clearRefundFilters: store.transactions.refundFilter.clearFilters,
    updateRefundedSelectedDateInfo: store.transactions.updateRefundedSelectedDateInfo,
    resetPaginationNativeRefunded: store.transactions.resetPaginationNativeRefunded,
    setSearchString: store.settings.metaData?.setSearchString,
  }))

  const [isLoadingMore, setLoadMore] = useState(false)
  const layoutRef: any = useRef(null)

  const canFetchMoreTxns = moreTxnAvailable(Routes.TRANSACTIONS)
  const recivedTransctionList = fetchDataForTransactionTab(tableConfig(Routes.TRANSACTIONS).tabletype)

  const loadingState = getLoadingState(transactionApiHandlers)
  const viewMoreLoadingState = getLoadingState(transactionApiLoadMoreHandlers)
  const errorState = getErrorState(transactionApiHandlers)
  const loadMoreErrorState = getErrorState(transactionApiLoadMoreHandlers)

  const showEmptyImage = recivedTransctionList?.length === 0 && !loadingState && !errorState

  // const [filtersData, setFiltersData] = useState(JSON.parse(JSON.stringify(selectedReceivedFiltersData)))
  // const [filtersList, setFiltersList] = useState(getFilterList(selectedReceivedFiltersData))

  const isLargeScreen = useIsLargeScreen()
  const filtersList = getFilterList(filtersData)
  const ismobile = isMobile(isLargeScreen)
  useEffect(() => {
    if (!loadingState && isLoadingMore) {
      setLoadMore(false)
    }
  }, [isLoadingMore, loadingState])

  const [loadMoreRetryVisible, setLoadMoreRetryVisible] = useState(false)

  useEffect(() => {
    setLoadMoreRetryVisible(loadMoreErrorState)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionApiLoadMoreHandlers?.[1]?.state])

  useEffect(() => {
    if (isFocused) {
      setSearchString('')
      resetRefundFilters()
      resetFilters()
      onRefresh()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused])

  const filterDateSelected = filtersData?.selectedDateInfo?.fromDate && filtersData?.selectedDateInfo?.toDate
  const viewOlderRecords =
    !isMaxDateRangeSelected(selectedDateInfo) &&
    selectedDateInfo?.dateLabel === actionMenuStrings.infiniteScrollRange &&
    !filterDateSelected
  const abortControllerRef = useRef<AbortController>()
  useEffect(() => {
    if (mid) {
      let dateObject = selectedDateInfo
      if (filtersData?.selectedDateInfo?.fromDate && filtersData?.selectedDateInfo?.toDate) {
        console.log('consider filter dates until clear filter')
        dateObject = filtersData?.selectedDateInfo
      }
      abortControllerRef?.current?.abort()
      abortControllerRef.current = new AbortController()
      fetchTransactionDetailsOfPath(
        fetchTxnColumns,
        fetchTxn,
        true,
        dateObject,
        pagination,
        false,
        ismobile,
        abortControllerRef?.current,
      )
      fetchStatsApi(mid, 'transactions', selectedDateInfoObj)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    fetchTransactionDetailsOfPath,
    fetchTxn,
    fetchTxnColumns,
    pagination,
    selectedDateInfo,
    filtersData?.selectedDateInfo,
    mid,
  ])

  const loadPrevPeriodRecords = () => {
    if (
      !isMaxDateRangeSelected(selectedDateInfo) &&
      selectedDateInfo?.dateLabel === actionMenuStrings.infiniteScrollRange
    ) {
      abortControllerRef?.current?.abort()
      abortControllerRef.current = new AbortController()
      fetchTransactionDetailsOfPath(
        fetchTxnColumns,
        fetchTxn,
        true,
        {
          fromDate: new Date(getPrevDate(new Date(selectedDateInfo?.fromDate), INFINITE_SCROLL_WINDOW)),
          toDate: new Date(getPrevDate(new Date(selectedDateInfo?.toDate), INFINITE_SCROLL_WINDOW)),
          dateLabel: actionMenuStrings.infiniteScrollRange,
        },
        pagination,
        false,
        ismobile,
        abortControllerRef?.current,
      )

      updateSelectedDateInfo({
        fromDate: new Date(getPrevDate(new Date(selectedDateInfo?.fromDate), INFINITE_SCROLL_WINDOW)),
        toDate: new Date(getPrevDate(new Date(selectedDateInfo?.toDate), INFINITE_SCROLL_WINDOW)),
        dateLabel: actionMenuStrings.infiniteScrollRange,
      })
    }
  }

  const onLoadMore = (isRetry?: boolean) => {
    let dateObject = selectedDateInfo
    setLoadMoreRetryVisible(false)
    if (filtersData?.selectedDateInfo?.fromDate && filtersData?.selectedDateInfo?.toDate) {
      console.log('consider filter dates until clear filter')
      dateObject = filtersData?.selectedDateInfo
    }
    if (!isRetry && !canFetchMoreTxns && !isMaxDateRangeSelected(dateObject)) {
      const dateObj = {
        toDate: selectedDateInfo?.fromDate?.getTime(),
        fromDate: getPrevDate(selectedDateInfo?.fromDate, INFINITE_SCROLL_WINDOW),
        dateLabel: actionMenuStrings.infiniteScrollRange,
      }
      updateSelectedDateInfo(dateObj)
      paginationResetToZero()
    }
    setLoadMore(true)
    abortControllerRef?.current?.abort()
    abortControllerRef.current = new AbortController()
    loadMoreTxns(fetchTxnOnLoadMore, fetchTxnColumnsOnLoadMore, dateObject, filtersData, abortControllerRef?.current)
  }

  const onRefresh = () => {
    updateSelectedDateInfo({
      fromDate: getSelectedDate(INFINITE_SCROLL_WINDOW_INDEX),
      toDate: new Date(Date.now()),
      dateLabel: actionMenuStrings?.infiniteScrollRange,
    })
    let dateObject = selectedDateInfo
    if (filtersData?.selectedDateInfo?.fromDate && filtersData?.selectedDateInfo?.toDate) {
      console.log('consider filter dates until clear filter')
      dateObject = filtersData?.selectedDateInfo
    } else {
      dateObject = selectedDateInfo
    }
    resetPaginationTxn()
    abortControllerRef?.current?.abort()
    abortControllerRef.current = new AbortController()
    fetchTransactionDetailsOfPath(
      fetchTxnColumns,
      fetchTxn,
      true,
      dateObject,
      pagination,
      true,
      ismobile,
      abortControllerRef?.current,
    )
  }

  const getEmptyMessage = (): string => {
    if (!loadingState) {
      return recivedTransctionList.length === 0 ? transactionScreenStrings.noRecords : transactionScreenStrings.empty
    }
    return ''
  }

  const handleRetry = (): void => {
    setLoadMoreRetryVisible(false)
    let dateObject = selectedDateInfo
    if (filtersData?.selectedDateInfo?.fromDate && filtersData?.selectedDateInfo?.toDate) {
      console.log('consider filter dates until clear filter')
      dateObject = filtersData?.selectedDateInfo
    }
    abortControllerRef?.current?.abort()
    abortControllerRef.current = new AbortController()
    onTransactionRetry(fetchTxn, fetchTxnColumns, dateObject, ismobile, abortControllerRef?.current)
  }

  const handleItemPress = (item: any) => {
    if (canViewTransactionDetails || isOsMobile()) {
      logEvent('item_press', 'received_payments')
      updateSelectedTxn(item.id)
      navigation.navigate(Routes.TRANSACTIONS_DETAILS, {
        transactionId: item?.id,
        path: Routes.TRANSACTIONS,
        transactionDate: item?.date,
        tab: 'received',
      })
    } else {
      RootStore?.response?.setCustomToast({
        message: staticStrings.notAuthorized,
        color: defaultColors.RED,
        position: ToastPosition.BOTTOM,
        toastType: ToastType.NEGATIVE,
        minWidthOfLeftBox: 200,
      })
    }
  }

  const isEmptyView = showEmptyImage || (errorState && recivedTransctionList.length === 0)
  const RefreshControl = isOsMobile() ? RefreshControlMobile : RefreshControlMobileWeb

  const dateFilterSelected =
    filtersData?.selectedDateInfo?.fromDate && filtersData?.selectedDateInfo?.toDate ? true : false

  const emptyView = () => {
    return (
      <ScrollView
        contentContainerStyle={{ flexGrow: 1, justifyContent: 'center', alignItems: 'center' }}
        refreshControl={<RefreshControl refreshing={false} onRefresh={onRefresh} />}>
        <ImageWithInfoSerializer
          show={showEmptyImage}
          screenName={Routes.TRANSACTIONS}
          actionButtonVisible={viewOlderRecords}
          actionButtonName={'View older Records'}
          onPress={loadPrevPeriodRecords}
        />
      </ScrollView>
    )
  }

  const resetFilters = () => {
    setLoadMoreRetryVisible(false)
    const defaultDateObj = {
      fromDate: getSelectedDate(INFINITE_SCROLL_WINDOW_INDEX),
      toDate: new Date(Date.now()),
      position: {
        top: 0,
        left: 0,
        visible: false,
      },
      dateLabel: actionMenuStrings?.infiniteScrollRange,
    }
    clearReceivedFilters()
    updateSelectedDateInfo(defaultDateObj)
  }

  const resetRefundFilters = () => {
    const defaultDateObj = {
      fromDate: getSelectedDate(INFINITE_SCROLL_WINDOW_INDEX),
      toDate: new Date(Date.now()),
      position: {
        top: 0,
        left: 0,
        visible: false,
      },
      dateLabel: actionMenuStrings?.infiniteScrollRange,
    }
    resetPaginationNativeRefunded()
    clearRefundFilters()
    updateRefundedSelectedDateInfo(defaultDateObj)
  }

  return (
    <>
      <SearchBarWithFilters
        filterList={filtersList}
        filtersData={filtersData}
        clearLoadMoreError={resetFilters}
        onApply={() => {
          let dateObject = selectedDateInfo
          if (filtersData?.selectedDateInfo?.fromDate && filtersData?.selectedDateInfo?.toDate) {
            console.log('consider filter dates until clear filter')
            dateObject = filtersData?.selectedDateInfo
          }
          setLoadMoreRetryVisible(false)
          abortControllerRef?.current?.abort()
          abortControllerRef.current = new AbortController()
          layoutRef.current = { y: 1 }
          fetchTransactionDetailsOfPath(
            fetchTxnColumns,
            fetchTxn,
            true,
            dateObject,
            pagination,
            false,
            ismobile,
            abortControllerRef?.current,
          )
        }}
        index={0}
      />
      <Box
        f={1}
        overflow={isOsMobile() ? undefined : 'auto'}
        bg={'WHITE'}
        align={isEmptyView || errorState ? 'center' : undefined}
        justify={isEmptyView || errorState ? 'center' : 'flex-start'}>
        <ImageWithInfoSerializer
          show={errorState}
          screenName={'errorTxn'}
          actionButtonVisible={true}
          actionButtonName={'Try Again'}
          onPress={handleRetry}
        />
        <ListWithDateRange
          data={recivedTransctionList}
          refreshControl={<RefreshControl refreshing={false} onRefresh={onRefresh} />}
          handleItemPress={handleItemPress}
          canFetchMoreTxns={canFetchMoreTxns}
          isMaxDateRangeSelected={dateFilterSelected ? true : isMaxDateRangeSelected(selectedDateInfo)}
          path={Routes.TRANSACTIONS}
          isSeeAllVisible={false}
          onListFooterPress={onLoadMore}
          showShimmerView={viewMoreLoadingState}
          loadMoreErrorState={loadMoreRetryVisible}
          hide={errorState || (loadingState && !isLoadingMore)}
          newDataFetch={layoutRef?.current}
          layoutRef={layoutRef}
          listEmptyComponent={emptyView}
        />
        {loadingState && !isLoadingMore && <ShimmerView type={Routes.TRANSACTIONS} />}
      </Box>
    </>
  )
}
export { ReceivedTransactionNative }
